import { cloneElement } from 'react'
import { ExportButton, sanitizeListRestProps, TopToolbar } from 'react-admin'

/*
Source: https://marmelab.com/react-admin/doc/3.4/List.html#actions

Defines custom ListActions React-Admin component that includes an export button with a larger-than-default max-results.
*/
export const ListActionsLargeExport = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter,
  filterValues,
  permanentFilter,
  hasCreate,
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  customActions,
  ...rest
}: any) => (
  <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    {customActions}
    <ExportButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filterValues={{ ...filterValues, ...permanentFilter }}
      exporter={exporter}
      maxResults={5000}
    />
  </TopToolbar>
)

ListActionsLargeExport.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
}
